import { selectIsLoading } from '@views/loginView/state/loginSlice'
import React, { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { userProfile } from '@views/profile/state/profileSlice'
import { Role } from '@types'

const PrivateRoute: React.FC<{
  children: ReactNode
  path: string
  exact: boolean
  blockedRoles?: Role[]
}> = props => {
  const { isLogged } = useSelector(selectIsLoading)
  const { role } = useSelector(userProfile)

  if (!isLogged) return <Redirect to="/login" />
  if (props.blockedRoles?.includes(role)) return <Redirect to="/" />

  return (
    <Route path={props.path} exact={props.exact}>
      {props.children}
    </Route>
  )
}
export default PrivateRoute
